import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';
import { AES } from 'crypto-ts';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  isLoading = new Subject<boolean>();
  show() {
    this.isLoading.next(true);
  }
  hide() {
    this.isLoading.next(false);
  }

  constructor() { }

  decryptionAES(msg) {
    //

    var today = new Date();
    var month = this.pad(today.getMonth() + 1, 2, 0);
    var date = this.pad(today.getDate(), 2, 0);
    //const cryptoInfo = CryptoTS.AES.encrypt(JSON.stringify({ msg }), today.getFullYear() + "" + month + "" + date + "1201").toString();
    //
    const secret = 'abcdefg';
    const bytes = CryptoTS.AES.decrypt(msg, today.getFullYear() + "" + month + "" + date + "12012023");
    console.log("Check encryption key generated : ",bytes, today.getFullYear() + "" + month + "" + date + "12012023")
    const plaintext = bytes.toString(CryptoTS.enc.Utf8);
    return plaintext;
  }
  EncryptAES(msg) {
    //

    var today = new Date();
    var month = this.pad(today.getMonth() + 1, 2, 0);
    var date = this.pad(today.getDate(), 2, 0);
    //const cryptoInfo = CryptoTS.AES.encrypt(JSON.stringify({ msg }), today.getFullYear() + "" + month + "" + date + "1201").toString();
    //
    const secret = 'abcdefg';
    let event = AES.encrypt(JSON.stringify(msg),  today.getFullYear() + "" + month + "" + date + "12012023").toString();
    // const bytes = Buffer.from(event, 'base64');
    // console.log('Bytes of patient post api data:', bytes);
  
    return event;
  }




  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}